<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="back-outer" routerLink="/">
  <p>Back to home</p>
</div>
<div class="driver-signup">
  <div class="driver-left-outer">
    <div class="driver-logo">
      <a routerLink="/">
      <img src="../../../assets/images/logo-white.svg" alt="" /></a>
    </div>
    <div class="discovery-heading">
      <h2>Discover the Easiest Way</h2>
      <h5>To Reserve your parking</h5>
    </div>
    <div class="img-group">
      <img src="../../../assets/images/group-list.png" alt="" />
    </div>
    <div class="mobile-imgouter">
      <img src="../../../assets/images/mobile-user.png" alt="" />
    </div>
  </div>
  <div class="driver-right-outer">
    <div class="driver-iiner" *ngIf="isSignUp">
      <div class="signup-outer">
        <h3>Signup</h3>
        <form [formGroup]="signupForm" (ngSubmit)="onSubmit(signupForm.value)">
          <div class="sign-inner">
            <div class="input-group">
              <div class="single-group">
                <label for="groupName">Company Name <span class="custom-star">*</span></label>
                <input id="groupName" type="text" [maxlength]="50" placeholder="Enter your Company Name" NoLeadingSpaceDirective
                  formControlName="groupName" pInputText />
                <div *ngIf="signupForm.get('groupName').touched" class="validation-error">
                  <div *ngIf="signupForm.get('groupName')?.hasError('required')">This field is required*</div>
                  <div *ngIf="signupForm.get('groupName')?.hasError('minlength')">Minimum 3 characters are required*
                  </div>
                  <div *ngIf="signupForm.get('groupName')?.hasError('maxlength')">Maximum 50 characters are required*
                  </div>
                </div>
              </div>
              <div class="single-group">
                <label for="dotNumber">DOT Number </label>
                <input id="dotNumber" type="text" [maxlength]="12" placeholder="Enter DOT number" NoLeadingSpaceDirective
                  formControlName="dotNumber" pattern="^[A-Za-z0-9]+$" pInputText />
                <div
                  *ngIf="signupForm.get('dotNumber').invalid && (signupForm.get('dotNumber').dirty || signupForm.get('dotNumber').touched)">
                  <div *ngIf="signupForm.get('dotNumber').hasError('pattern')">
                    <div class="validation-error">Dot Number is invalid.</div>
                  </div>
                  <div
                    *ngIf="signupForm.get('dotNumber').hasError('maxlength') && !signupForm.get('dotNumber').hasError('pattern')">
                    <div class="validation-error">Maximum 12 digits are required*</div>
                  </div>
                  <div
                    *ngIf="signupForm.get('dotNumber').hasError('minlength') && !signupForm.get('dotNumber').hasError('pattern')">
                    <div class="validation-error">Minimum 6 digits are required*</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="input-group">
              <div class="single-group">
                <label for="firstName">First Name <span class="custom-star">*</span></label>
                <input id="firstName" type="text" [maxlength]="50" placeholder="Enter your first name" NoLeadingSpaceDirective
                  formControlName="firstName" pInputText />
                <div *ngIf="signupForm.get('firstName')?.touched || signupForm.get('firstName')?.dirty" class="validation-error">

<div *ngIf="signupForm.get('firstName')?.hasError('required')">
                  This field is required*
                </div>

<div *ngIf="!signupForm.get('firstName')?.hasError('required') &&
                            signupForm.get('firstName')?.hasError('leadingSpace')">
                  Last Name cannot start with a space.*
                </div>

<div *ngIf="!signupForm.get('firstName')?.hasError('required') &&
                            !signupForm.get('firstName')?.hasError('leadingSpace') &&
                            signupForm.get('firstName')?.hasError('pattern')">
                  Please enter only characters*
                </div>

<div *ngIf="!signupForm.get('firstName')?.hasError('required') &&
                            !signupForm.get('firstName')?.hasError('leadingSpace') &&
                            !signupForm.get('firstName')?.hasError('pattern') &&
                            signupForm.get('firstName')?.hasError('minlength')">
                  Minimum 3 characters are required*
                </div>

<div *ngIf="!signupForm.get('firstName')?.hasError('required') &&
                            !signupForm.get('firstName')?.hasError('leadingSpace') &&
                            !signupForm.get('firstName')?.hasError('pattern') &&
                            !signupForm.get('firstName')?.hasError('minlength') &&
                            signupForm.get('firstName')?.hasError('maxlength')">
                  Maximum 50 characters are required*
                </div>

              </div>
              </div>
              <div class="single-group">
                <label for="lastName">Last Name<span *ngIf="requiredLastNameAsterisk"
                    class="custom-star">*</span></label>
              <input id="lastName" type="text" [maxlength]="50" placeholder="Enter your Last name" NoLeadingSpaceDirective
                formControlName="lastName" pInputText />

              <div *ngIf="signupForm.get('lastName')?.touched || signupForm.get('lastName')?.dirty" class="validation-error">

<div *ngIf="signupForm.get('lastName')?.hasError('required')">
                  This field is required*
                </div>

<div *ngIf="!signupForm.get('lastName')?.hasError('required') &&
                            signupForm.get('lastName')?.hasError('leadingSpace')">
                  Last Name cannot start with a space.*
                </div>

<div *ngIf="!signupForm.get('lastName')?.hasError('required') &&
                            !signupForm.get('lastName')?.hasError('leadingSpace') &&
                            signupForm.get('lastName')?.hasError('pattern')">
                  Please enter only characters*
                </div>

<div *ngIf="!signupForm.get('lastName')?.hasError('required') &&
                            !signupForm.get('lastName')?.hasError('leadingSpace') &&
                            !signupForm.get('lastName')?.hasError('pattern') &&
                            signupForm.get('lastName')?.hasError('minlength')">
                  Minimum 3 characters are required*
                </div>

<div *ngIf="!signupForm.get('lastName')?.hasError('required') &&
                            !signupForm.get('lastName')?.hasError('leadingSpace') &&
                            !signupForm.get('lastName')?.hasError('pattern') &&
                            !signupForm.get('lastName')?.hasError('minlength') &&
                            signupForm.get('lastName')?.hasError('maxlength')">
                  Maximum 50 characters are required*
                </div>

              </div>
              </div>
            </div>
            <div class="input-group">
              <div class="single-group">
                <label for="email">Email <span *ngIf="requiredLastNameAsterisk"
                    class="custom-star">*</span></label>
                <input id="email" type="text" [maxlength]="50" placeholder="Enter Email" NoLeadingSpaceDirective
                  formControlName="email" pInputText />
                <div
                  *ngIf="signupForm.get('email').invalid && (signupForm.get('email').dirty || signupForm.get('email').touched)"
                  class="validation-error">
                  <div *ngIf="signupForm.get('email')?.hasError('required')">This field is required*</div>
                  <div *ngIf="signupForm.get('email')?.hasError('pattern')">Invalid email.</div>
                </div>
              </div>
              <div class="single-group">
                <label for="phoneNumber">Mobile Number <span *ngIf="requiredLastNameAsterisk"
                    class="custom-star">*</span></label>
                <ngx-intl-tel-input id="phoneNumber" [cssClass]="'custom'" [preferredCountries]="preferredCountries" [disabled]="true"
                  [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                  [searchCountryField]="[searchCountryField.Iso2,searchCountryField.Name]" [selectFirstCountry]="false"
                  [selectedCountryISO]="countryISO" [maxLength]="10" [phoneValidation]="true"
                  customPlaceholder="Enter Mobile Number" [separateDialCode]="separateDialCode"
                  [numberFormat]="phoneNumberFormat.National" name="phone" formControlName="phoneNumber">
                </ngx-intl-tel-input>
                <div
                  *ngIf="signupForm.get('phoneNumber').hasError('required') && signupForm.get('phoneNumber').dirty && signupForm.get('phoneNumber').touched">
                  <small class="validation-error">This field is required*</small>
                </div>
                <div
                  *ngIf="!signupForm.get('phoneNumber').hasError('required') && signupForm.get('phoneNumber').touched && signupForm.get('phoneNumber').invalid">
                  <small class="validation-error">Mobile number is not valid*</small>
                </div>
              </div>
            </div>
            <div class="input-group">
              <div class="single-group">
                <label for="password">Password <span class="custom-star">*</span></label>
                <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false
                  id="password" placeholder="Enter Password" maxlength="15"
                  (keydown)="onPasswordKeyDown($event, 'password')" formControlName="password"></p-password>
                <div class="error-outer"
                  *ngIf="signupForm.get('password').invalid && (signupForm.get('password').dirty || signupForm.get('password').touched)">
                  <div *ngIf="signupForm.get('password').hasError('required')" class="validation-error">Password is
                    required.</div>
                  <div *ngIf="signupForm.get('password').hasError('invalidPassword')" class="validation-error">
                    Length must be 8-15 with uppercase, lowercase, <br />number & special characters.
                  </div>
                </div>
              </div>
              <div class="single-group">
                <label for="confirmPassword">Confirm Password <span class="custom-star">*</span></label>
                <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false
                  id="confirmPassword" placeholder="Enter Password" maxlength="15"
                  (keydown)="onPasswordKeyDown($event, 'confirmPassword')"
                  formControlName="confirmPassword"></p-password>
                <div class="error-outer"
                  *ngIf="signupForm.get('confirmPassword').invalid && (signupForm.get('confirmPassword').dirty || signupForm.get('confirmPassword').touched)">
                  <div *ngIf="signupForm.get('confirmPassword').hasError('required')" class="validation-error">Confirm
                    Password is
                    required.</div>
                  <div *ngIf="signupForm.get('confirmPassword').hasError('invalidPassword')" class="validation-error">
                    Length must be 8-15 with uppercase, lowercase,<br /> number & special characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="group-btn">
              <button type="submit" pButton label="Create account"></button>
            </div>
            <div class="account-login">
              <p>Already have an account? <a (click)="redirect()">Login</a></p>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="verfication-outer" *ngIf="showOtpComponent">
      <div class="card">
        <h3>Verification</h3>
        <p class="code-sent">Please type the verification code
        </p>
        <div class="input-outer">
          <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
        </div>
      </div>
      <div class="otp-btn">
        <div class="group-btn">
          <button (click)="verifyEmailByOTP()" type="submit" pButton label="Continue"></button>
        </div>
        <h5 *ngIf="showButton">Didn't receive a code? <span style="cursor: pointer;"
            (click)="onClickSendOtp($event)">Please Resend</span></h5>
        <p *ngIf="!showButton" class="resend">Resend passcode in {{ countDown }}</p>
      </div>
    </div>
  </div>
</div>
